module.exports = __webpack_public_path__ + "img/developers-icon.0a319881.svg";